export const REFERRAL_KEY = "ReferralCode";
